import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { CheckSquare, CheckCircle2, CalendarClock, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Followups() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const load = () => api.get("/followups").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const complete = async (id, done) => { await api.put(`/followups/${id}`, { done: !done }); load(); };
  const remove = async (id) => { await api.delete(`/followups/${id}`); toast.success("Follow-up removido."); load(); };

  const today = new Date().toISOString().slice(0, 10);
  const pending = items.filter((f) => !f.done);
  const overdue = pending.filter((f) => f.due_date < today);
  const todayItems = pending.filter((f) => f.due_date.startsWith(today));

  return (
    <div className="space-y-6 animate-fade-up" data-testid="followups-page">
      <div><h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">Tarefas & Follow-ups</h1><p className="text-sm text-slate-500 mt-1">Acompanhe contatos futuros com seus clientes.</p></div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <Stat label="Para hoje" value={todayItems.length} color="text-emerald-600" />
        <Stat label="Atrasados" value={overdue.length} color="text-red-500" />
        <Stat label="Pendentes" value={pending.length} color="text-amber-600" />
      </div>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm divide-y divide-slate-100" data-testid="followups-list">
        {items.length === 0 && <p className="text-center py-12 text-slate-400 text-sm">Nenhum follow-up cadastrado. Crie um no perfil de um cliente.</p>}
        {items.map((f) => (
          <div key={f.id} className={`flex items-center gap-3 p-4 ${f.done ? "opacity-50" : ""}`}>
            <button onClick={() => complete(f.id, f.done)} data-testid={`followup-complete-${f.id}`}>
              {f.done ? <CheckCircle2 className="h-5 w-5 text-emerald-500" /> : <CheckSquare className="h-5 w-5 text-slate-300 hover:text-emerald-500" />}
            </button>
            <div className="flex-1 min-w-0 cursor-pointer" onClick={() => f.client_id && navigate(`/clientes/${f.client_id}`)}>
              <p className="text-sm font-medium text-slate-800">{f.client_name}</p>
              {f.note && <p className="text-xs text-slate-500 truncate">{f.note}</p>}
            </div>
            <span className={`text-xs flex items-center gap-1 ${f.due_date < today && !f.done ? "text-red-500" : "text-slate-400"}`}>
              <CalendarClock className="h-3.5 w-3.5" /> {fmtDate(f.due_date)}
            </span>
            <button onClick={() => remove(f.id)} className="text-slate-300 hover:text-red-500"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}

function Stat({ label, value, color }) {
  return <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm text-center"><p className={`text-3xl font-bold font-display ${color}`}>{value}</p><p className="text-xs text-slate-500 mt-1">{label}</p></div>;
}
